import { faAngleDown, faAngleUp, faArrowDown, faArrowsRotate, faArrowUp, faSearch, faSort, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import { Badge, Button, Dropdown, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { POST } from '../../api';
import { CerisePink, GoldenPoppy, GraniteGray, Gray, SilverSand, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { updateShoppingCart } from '../../redux/slices/marketPlaceSlice';
import Pagination from '../_partials/Pagination';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
const portalURL = process.env.REACT_APP_PORTAL_URL;

/**
 * MarketPlace Component
 */
class OrdersMarketPlace extends Component {

    servicesTypes = [
        { value: 0, label: 'Service' },
        { value: 1, label: 'Inventory' },
        { value: 2, label: 'Resources' },
        { value: 3, label: 'Assets' },
    ];
    searchFieldRef = React.createRef()
    state = {
        cdt: {
            fetching: false,
            search: '',
            rows: 10,
            offset: 0,
            order: 'addservicesheader.addservicesheader_id',
            dir: 'DESC',
            lastPage: 0,
            page: 0,
            totalRecords: 0,
            rowsOptions: [10, 25, 50, 'All'],
            columns: [
                {
                    id: 'addservicesheader.addservicesheader_id',
                    column: 'addservicesheader_id',
                    name: 'Newly Added',
                    sortable: true
                },
                {
                    id: 'addservicesheader.addservices_num',
                    column: 'addservices_num',
                    name: 'Order Number',
                    sortable: true
                },
                {
                    id: 'addservicesheader.addservicesheader_amount',
                    column: 'addservicesheader_amount',
                    name: 'Amount',
                    sortable: true
                },
            ],
            data: [],
        },
    }

    componentDidMount() {
        const {
            search,
            rows: limit,
            order,
            dir
        } = this.state.cdt;
        this.fetch({ search: search, limit: limit, order: order, dir: dir, page: 0 })
    }

    fetch = async ({ search, limit, order, dir, page }) => {

        this.setState({
            cdt: {
                ...this.state.cdt,
                fetching: true,
            }
        });

        if (this.fetchReq) {
            this.fetchReq.abort();
        }
        this.fetchReq = new AbortController();

        try {
            let fData = new FormData()
            fData.append('filterServiceType', JSON.stringify(this.state.filterServiceType))
            const res = await POST('market-place/get-sales-order', fData, {
                signal: this.fetchReq.signal,
                params: {
                    search,
                    order,
                    dir,
                    limit,
                    offset: parseInt(page) * parseInt(limit),
                    child_id: this.props.selectedChild.child_id
                },
            });

            if (res.status === 200) {
                this.setState({
                    cdt: {
                        ...this.state.cdt,
                        fetching: false,
                        search,
                        rows: parseInt(limit),
                        offset: parseInt(page) * parseInt(limit),
                        order,
                        dir,
                        page,
                        totalRecords: parseInt(res.data.total_count_filtered),
                        lastPage: Math.ceil(parseInt(res.data.total_count_filtered) / parseInt(limit)),
                        data: res.data.data,
                    }
                });
            }

        } catch (err) {
            console.log('err', err)
            this.setState({
                cdt: {
                    ...this.state.cdt,
                    fetching: false,
                }
            });

        }
    }

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        let { cdt, filterServiceType } = this.state
        let { authData } = this.props
        let currencycode = authData.centerData.currencycode
        return (<div >
            <div className='d-flex flex-row align-items-center mb-4'>
                <div className='px-1' style={{ flex: 1 }}>
                    <div className='cdt-search' style={{ height: 38, width: '100%', borderRadius: 20 }}>
                        <input
                            style={{
                                paddingLeft: 17
                            }}
                            type='text'
                            ref={this.searchFieldRef}
                            defaultValue={cdt.search}
                            onChange={(e) =>
                                this.fetch({
                                    search: e.target.value,
                                    limit: cdt.rows,
                                    order: cdt.order,
                                    dir: cdt.dir,
                                    page: 0,
                                })
                            }
                            placeholder={t('Search...')}
                        />
                        <button
                            onClick={() => {
                                this.fetch({
                                    search: '',
                                    limit: cdt.rows,
                                    order: cdt.order,
                                    dir: cdt.dir,
                                    page: 0,
                                });
                                this.searchFieldRef.current.value = '';
                            }}>
                            <FontAwesomeIcon
                                icon={cdt.search == '' ? faSearch : faXmark}
                                color={Gray}
                            />
                        </button>
                    </div>
                </div>
                <div className='d-flex flex-row align-items-center px-1'>
                    <div className='me-2' style={{ display: 'inline-block' }}>
                        <Dropdown>
                            <Dropdown.Toggle variant="light"
                                style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}>
                                {t('Show:') + ' ' + (cdt.rows == -1 ? 'All' : cdt.rows)}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {cdt.rowsOptions.map((row, index) =>
                                    <Dropdown.Item onClick={() => this.fetch({
                                        search: cdt.search,
                                        limit: row,
                                        order: cdt.order,
                                        dir: cdt.dir,
                                        page: cdt.page,
                                    })
                                    }
                                        key={index}>{row == -1 ? 'All' : row}</Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className='me-2' style={{ display: 'inline-block' }}>
                        <Dropdown>
                            <Dropdown.Toggle variant='light'
                                style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }} className='crm-options-btn'>
                                <FontAwesomeIcon
                                    icon={faSort}
                                    style={{ fontSize: 13, marginRight: 5 }}
                                />{t('Sort')}
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: 180 }}>
                                {cdt.columns
                                    .filter(column => column.sortable)
                                    .map((column, index) => {
                                        return (
                                            <Dropdown.Item key={index}
                                                onClick={() => this.fetch({
                                                    search: cdt.search,
                                                    limit: cdt.rows,
                                                    order: column.id,
                                                    dir: (cdt.order == column.id) ? cdt.dir == 'ASC' ? 'DESC' : 'ASC' : 'DESC',
                                                    page: cdt.page,
                                                })}
                                                className='d-flex justify-content-between align-items-center'>
                                                {t(column.name)}
                                                {cdt.order == column.id &&
                                                    <FontAwesomeIcon
                                                        icon={cdt.dir == 'DESC' ? faArrowDown : faArrowUp}
                                                        style={{ fontSize: 12 }}
                                                    />}
                                            </Dropdown.Item>
                                        )
                                    })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className='d-flex flex-column p-2 grey-section' style={{ borderRadius: 10, height: '68vh', overflowY: 'auto' }}>
                {cdt.data.map((v, i) => {

                    // Number((this.state.balance).toFixed(2)).toLocaleString()
                    // let balance = (this.state.balance).toFixed(2)
                    // let center_id = this.props.centerData.center_id
                    // let user_id = this.props.loginData.user_id
                    // let child_id = this.props.activeHeader.child_id
                    // let child_name = this.props.activeHeader.child_name
                    // let payment_gateway_id = this.props.centerData.payment_gateway_id
                    // var payment_gateway_url = new URL(this.props.centerData.payment_gateway_url);
                    // payment_gateway_url.searchParams.append('p', balance + ',' + center_id + ',' + user_id + ',' + child_id + ',' + payment_gateway_id + ',' + child_name);
                    // payment_gateway_url.searchParams.append('auth_key', this.props.authKey);
                    // payment_gateway_url = payment_gateway_url.toString()
                    let addservicesheader_amount = v.addservicesheader_amount
                    let addservicesheader_vat = v.addservicesheader_vat



                    return <div key={i} style={{ width: '100%', fontSize: 14 }} className='py-2 px-2'>
                        <div style={{ flex: 1, backgroundColor: White, borderRadius: 10 }} className='d-flex flex-column p-2'>
                            <div className='d-flex flex-row justify-content-between'>
                                <div className='d-flex flex-row'>
                                    <div className='d-flex flex-column p-2' >
                                        <div style={{ fontWeight: 600 }}>Order ID</div>
                                        <div>{v.addservices_num}</div>
                                    </div>
                                    <div className='d-flex flex-column p-2' >
                                        <div style={{ fontWeight: 600 }}>Amount</div>
                                        <div>{(parseFloat(addservicesheader_amount) + parseFloat(addservicesheader_vat)).toFixed(2)}</div>
                                    </div>
                                    <div className='d-flex flex-column p-2' >
                                        <div style={{ fontWeight: 600 }}>Date</div>
                                        <div>{moment(v.addservicesheader_date).format('DD-MM-YYYY')}</div>
                                    </div>
                                </div>
                                <div className='d-flex flex-row'>
                                    <div className='d-flex flex-row align-items-center me-3 position-relative' >
                                        <div className='d-flex flex-row align-items-center me-3 position-relative' >
                                            {v.addservices.map((vv, ii) => {
                                                return <div key={ii} style={{ position: 'absolute', left: -(20 + (ii * 10)) }}>
                                                    <Image src={(vv.services_image)
                                                        ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/services/' + vv.services_image
                                                        : require('../../assets/images/placeholder150.png')} style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 10 }} />
                                                </div>
                                            })}
                                        </div>
                                        <div style={{ color: GraniteGray }}>{v.addservices.length + ' Items'}</div>
                                    </div>

                                    <div className='d-flex flex-column align-items-end' >
                                        <div className='d-flex flex-row justify-content-center align-items-center p-2 cursor-pointer' style={{ borderRadius: '100px', backgroundColor: '#fff', color: '#000', border: 'solid 2px #f6f6f6' }} onClick={() => {
                                            let newCdt = this.state.cdt
                                            newCdt.data[i].addservices_visible = (newCdt.data[i].addservices_visible) ? false : true
                                            this.setState({ cdt: newCdt })
                                        }}>
                                            <FontAwesomeIcon icon={(v.addservices_visible) ? faAngleUp : faAngleDown} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {v.addservices_visible &&
                                <div className='d-flex flex-column p-2 my-2' style={{ backgroundColor: '#fafafa', width: '100%', borderRadius: 10 }}>
                                    {v.addservices.map((vv, ii) => {
                                        let addservices_vat = vv.addservices_vat
                                        let addservices_quantity = vv.addservices_quantity
                                        let addservices_fee = vv.addservices_fee
                                        let addservices_vat_amount = addservices_fee * addservices_vat / 100
                                        let this_servicesTypes = this.servicesTypes.find((vvv) => vvv.value == vv.services_type)

                                        return <div key={ii} className='d-flex flex-row justify-content-between my-2 px-1' style={{ width: '100%' }}>
                                            <div className='d-flex flex-row'>
                                                <Image src={(vv.services_image)
                                                    ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/services/' + vv.services_image
                                                    : require('../../assets/images/placeholder150.png')} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 5 }} />
                                                <div className='ms-2 d-flex flex-column'>
                                                    <div className='d-flex flex-row'>
                                                        <div style={{ fontWeight: '600' }}>{vv.services_name}</div>
                                                        <div className='ms-1 px-2' style={{ height: 20, backgroundColor: GoldenPoppy, borderRadius: 10 }}>
                                                            {addservices_quantity}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-row align-items-center mb-1'>
                                                        <div style={{ fontWeight: 600, fontSize: 13, color: CerisePink }} className='me-1'>{currencycode + ' ' + (addservices_fee + addservices_vat_amount)}</div>
                                                        <div style={{ fontSize: 10, color: SilverSand, fontStyle: 'italic' }}>{'Includes VAT'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <Badge bg={(this_servicesTypes.value == 0) ? 'primary' : 'success'} >{this_servicesTypes.label}</Badge>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            }
                            <div className='d-flex flex-row align-items-start justify-content-between mt-2'>
                                <div>
                                    {(!v.paid) &&
                                        <Button variant='danger' size='sm' className='me-2'>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Button>
                                    }
                                    {(!v.paid) &&
                                        <NavLink className={'btn btn-warning btn-sm me-2'} to={'/market-place/new-market-place?order_num=' + v.addservices_num}>
                                            <FontAwesomeIcon icon={faArrowsRotate} />
                                        </NavLink>
                                    }
                                    {(!v.paid) &&
                                        <Button variant='danger' size='sm' className='me-2'>
                                            {t('Pay Now')}
                                        </Button>
                                    }
                                </div>
                                <Badge bg={(v.paid) ? 'success' : 'danger'}>
                                    {(v.paid) ? 'Paid' : 'Not Paid'}
                                </Badge>
                            </div>
                        </div>
                    </div>
                })
                }
            </div >
            <Pagination
                pageCount={this.state.cdt.lastPage || 1}
                forcePage={this.state.cdt.page}
                callbackParams={{
                    search: this.state.cdt.search,
                    limit: this.state.cdt.rows,
                    order: this.state.cdt.order,
                    dir: this.state.cdt.dir,
                }}
                callback={this.fetch}
            />
        </div >);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    shoppingCart: state.marketPlace.shoppingCart,
    selectedChild: state.selectedChild.data,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, { updateShoppingCart })(OrdersMarketPlace);
